import { UserPermission, UserRole } from 'gql'

const hasAdminAccess = (user: { type: UserRole }) =>
  (user?.type?.permissions || []).includes(UserPermission.AdminAccess)

export default hasAdminAccess
